module.exports = __webpack_public_path__ + "img/wcfa-face-border2.7a049749.svg";